import { useMemo } from "react";
import { useGetConfig } from "../api/v1";
import { mapRecordToSelectOptions, sortOptionsByLabel } from "../app/libs/utils";
import { SelectOption } from "../types/select";
import { getLoginResponse } from "../utils/getLoginResponse";

type UseGetBanksOptions = {
  usageType: string;
  isSorted?: boolean;
};

type UseGetBanksOptionsResult = {
  banksOptions: SelectOption[];
  isLoadingBanksOptions: boolean;
};

export function useGetBanksOptions(options: UseGetBanksOptions): UseGetBanksOptionsResult {
  const { usageType, isSorted = true } = options;

  const { orgId } = getLoginResponse();

  const { config, isLoadingConfig } = useGetConfig({
    params: { key: "bankList", orgId, usageType },
    isEnabled: Boolean(orgId && usageType),
  });

  const banksOptions = useMemo(() => {
    const bankList = config?.[0]?.bankList;
    if (!bankList) return [];

    const mapped = mapRecordToSelectOptions(bankList);

    if (isSorted) return sortOptionsByLabel(mapped);
    return mapped;
  }, [config, isSorted]);

  return { banksOptions, isLoadingBanksOptions: isLoadingConfig };
}
